import React from "react";
import { FlexRowBetween } from "../Style";

const BottomMenu = ({ data }) => {
  return (
    <FlexRowBetween
      style={{
        position: "fixed",
        bottom: "0",
        width: "100%",
        background:
          "linear-gradient(to right, rgba(41,59,90,0.95), rgba(123,150,196,0.95))",
        justifyContent: "space-evenly",
        zIndex: 2,
      }}
    >
      {data}
    </FlexRowBetween>
  );
};

export default BottomMenu;
